import { useMemo } from 'react';
import useService from '@modules/ServiceModule/useService';
import ServiceModule from '@modules/ServiceModule';
import { QueueRow } from './QueuesTable/types';

/**
 * Provides queue data for the outbound call modal sourced from RTCS via `useService`.
 * `number` resolves to `entrypoints[0]` from the service queue data.
 */
export const useServiceQueuesState = () => {
  const { queues, loading, userByContactCenterUserId } = useService();

  const mappedQueues: QueueRow[] = useMemo(
    () =>
      Object.values(queues).map((queue) => {
        const availableUsers = queue.memberIds.filter((memberId) => {
          const user = userByContactCenterUserId[memberId];
          return user ? ServiceModule.isUserAvailable(user) : false;
        }).length;

        return {
          id: queue.id,
          name: queue.name,
          number: queue.entrypoints?.[0] ?? '',
          availableUsers,
          estimatedWait: queue.status?.estimatedWait,
        };
      }),
    [queues, userByContactCenterUserId],
  );

  return { queues: mappedQueues, loading };
};
